import { useTranslation } from 'react-i18next'

import { Money } from '../../../../../types/booking/booking'
import { formatMoney, formatPoints } from '../../../../../utils/booking/booking'

type SummaryPricingDetailsProps = {
  prepaidCount: number
  paidCount: number
  /** What is left to pay, after refund points. */
  total?: Money
  /** Refund points paying part of the price. */
  pointsAmount?: number
  showPrepaid: boolean
  totalSubtitle?: string
}

export const SummaryPricingDetails = ({
  prepaidCount,
  paidCount,
  total,
  pointsAmount = 0,
  showPrepaid,
  totalSubtitle,
}: SummaryPricingDetailsProps) => {
  const { t } = useTranslation('bookings')

  return (
    <>
      <div className="summary-stats ph-col mt-16">
        {showPrepaid && (
          <div className="ph-row ph-between">
            <span className="muted">
              {t('booking.booking-courts.summary-panel.plan-covered-slots')}
            </span>
            <span className="mono">{prepaidCount}</span>
          </div>
        )}

        <div className="ph-row ph-between">
          <span className="muted">{t('booking.booking-courts.summary-panel.pay-per-play')}</span>
          <span className="mono">{paidCount}</span>
        </div>

        {pointsAmount > 0 && (
          <div className="ph-row ph-between">
            <span className="muted">{t('booking.booking-courts.summary-panel.refund-points')}</span>
            <span className="mono text-success">
              {t('booking.booking-courts.summary-panel.refund-points-value', { points: formatPoints(pointsAmount) })}
            </span>
          </div>
        )}
      </div>

      <div className="sum-total">
        <div>
          <div className="eyebrow">{t('booking.booking-courts.summary-panel.total')}</div>
          {totalSubtitle && <div className="mono tiny muted">{totalSubtitle}</div>}
        </div>
        <div className="value">{total ? formatMoney(total) : '—'}</div>
      </div>
    </>
  )
}
